export const userParams = {
  moduleName: "LASER",
  calendarEndDate: "2024-10-03",
  startFromAppointment: false,
  showFutureAppointment: true,
  showProspectTypesFilter: true,
  showFutureAppointmentByDefault: true,
  showLaserNetworkAverages: true
};

export const funnelLaserChart = {
  startDate: "2021-07-01",
  endDate: "2021-07-20",
  first_data_date: "2020-01-21",
  funnel_laser: {
    total: {
      value: 1576,
      label: "Total Leads"
    },
    averageNumberOfDaysToConversion: {
      value: 1,
      label: "Avg. Days to Conversion"
    },
    chart: {
      title: "Leads Breakdown",
      leadRawDataLink:
        "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=appointment\u0026filters%5Bcategory_type_id%5D=\u0026filters%5Bpurchases_in_conversion%5D=false\u0026filters%5Bshow_future_appointment%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3ALeadsConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
      showPercentOfAppointment: 0.9631,
      enrollmentPercentOfShow: 0.8612,
      enrollmentPercentOfLead: 0.6415,
      enrollmentsMembershipRawDataLink:
        "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=converted\u0026filters%5Bcategory_type_id%5D=0\u0026filters%5Bpurchases_in_conversion%5D=false\u0026filters%5Bshow_future_appointment%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3ALeadsConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
      enrollmentsIntroRawDataLink:
        "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=converted\u0026filters%5Bcategory_type_id%5D=1\u0026filters%5Bpurchases_in_conversion%5D=false\u0026filters%5Bshow_future_appointment%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3ALeadsConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
      enrollmentsPackageRawDataLink:
        "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=converted\u0026filters%5Bcategory_type_id%5D=2\u0026filters%5Bpurchases_in_conversion%5D=false\u0026filters%5Bshow_future_appointment%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3ALeadsConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
      labels: ["Lead", "Appointment", "Show", "Enrollment"],
      subLabels: ["Unassigned", "Membership", "Package", "Intro Offer"],
      percentLabels: [
        ["Lead to Appointment"],
        ["Lead to Show", "Appointment to Show"],
        ["Lead to Enrollment", "Show to Enrollment"]
      ],
      values: [
        [1576, 0, 0, 0],
        [1219, 0, 0, 0],
        [1174, 0, 0, 0],
        [0, 4, 14, 993]
      ],
      rawDataValues: [
        "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=\u0026filters%5Bcategory_type_id%5D=\u0026filters%5Bpurchases_in_conversion%5D=false\u0026filters%5Bshow_future_appointment%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3ALeadsConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
        "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=appointment\u0026filters%5Bcategory_type_id%5D=\u0026filters%5Bpurchases_in_conversion%5D=false\u0026filters%5Bshow_future_appointment%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3ALeadsConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
        "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=show\u0026filters%5Bcategory_type_id%5D=0%2C1%2C2\u0026filters%5Bpurchases_in_conversion%5D=false\u0026filters%5Bshow_future_appointment%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3ALeadsConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
        "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=converted\u0026filters%5Bcategory_type_id%5D=\u0026filters%5Bpurchases_in_conversion%5D=false\u0026filters%5Bshow_future_appointment%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3ALeadsConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01"
      ],
      subPercents: ["", 0.9631, 0.8612]
    }
  }
};

export const tableData = {
  startDate: "2021-07-01",
  endDate: "2021-07-20",
  first_data_date: "2020-01-21",
  referrals_table: {
    tableInfo: {
      data: [
        ["Unassigned", 1424, 1118, 1078, 925, 0.6495786516853933, 46256.0, 32.48314606741573],
        ["Other", 152, 101, 96, 86, 0.5657894736842105, 3202.0, 21.06578947368421]
      ],
      colHeaders: [
        "Referral Source",
        "Leads",
        "Appointments",
        "Shows",
        "Conversion",
        "Conversion %",
        "Total Spend",
        "Spend Per Referral Source"
      ],
      columns: [
        { type: "text" },
        { type: "numeric", numericFormat: { pattern: "0,0" } },
        { type: "numeric", numericFormat: { pattern: "0,0" } },
        { type: "numeric", numericFormat: { pattern: "0,0" } },
        { type: "numeric", numericFormat: { pattern: "0,0" } },
        { type: "numeric", numericFormat: { pattern: "0,0.0 %" } },
        { type: "numeric", numericFormat: { pattern: "$0,0", culture: "en-US" } },
        { type: "numeric", numericFormat: { pattern: "$0,0.00", culture: "en-US" } }
      ],
      rowCalculations: [
        null,
        {
          type: "sum",
          rows: null
        },
        {
          type: "sum",
          rows: null
        },
        {
          type: "sum",
          rows: null
        },
        {
          type: "sum",
          rows: null
        },
        {
          type: "average",
          rows: [1, 4]
        },
        {
          type: "sum",
          rows: null
        },
        {
          type: "average",
          rows: [1, 6]
        }
      ]
    }
  }
};

export const introOfferData = {
  primaryStats: [
    {
      label: "Intros Sold",
      value: 1773,
      url: "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=\u0026filters%5Bpurchases_in_conversion%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3AIntroOffersConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01"
    },
    {
      label: "First Visits",
      value: 1517,
      url: "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=first_visits\u0026filters%5Bpurchases_in_conversion%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3AIntroOffersConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01"
    },
    {
      label: "Retained",
      value: 875,
      url: "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=retained\u0026filters%5Bpurchases_in_conversion%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3AIntroOffersConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01"
    }
  ],
  secondaryStats: [
    { label: "Avg. Days To First Visit", value: 1 },
    { label: "Avg. Days to Retained", value: 2 },
    { label: "Avg. Days to Conversion", value: 3 },
    { label: "Avg. Days To Membership Conversion", value: 5 }
  ],
  chart: {
    label: "Intro Conversion",
    legends: ["", "Membership", "Non Membership Service"],
    values: [
      [1773, 0, 0],
      [1517, 0, 0],
      [0, 16, 24]
    ],
    data: [
      { label: "Intros Sold", value: 1773, percentageData: [] },
      {
        label: "First Visit",
        value: 1517,
        percentageData: [{ label: "Intro to First Visit", value: 0.8556 }]
      },
      {
        label: "Converted",
        value: 40,
        percentageData: [
          { label: "Intros to Converted", value: 0.0226 },
          { label: "First Visit to Converted", value: 0.0264 }
        ]
      }
    ],
    rawDataValues: [
      "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=\u0026filters%5Bpurchases_in_conversion%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3AIntroOffersConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
      "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=first_visits\u0026filters%5Bpurchases_in_conversion%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3AIntroOffersConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01",
      "/organizations/1166/raw_datas?end_date=2021-07-20\u0026filters%5Bcategory_type%5D=converted\u0026filters%5Bpurchases_in_conversion%5D=false\u0026location_id=-1\u0026object_id=243249\u0026raw_data_view_class=RawDataViews%3A%3ARetention%3A%3AFunnelLaserChart%3A%3AIntroOffersConversionRawDataView\u0026region_id=-1\u0026start_date=2021-07-01"
    ]
  }
};
